import { Descriptions } from 'antd';
import React from 'react';

import { getTripDate } from '../../utils/datetime';
import RadarDashboardButton from './RadarDashboardButton';

const TripAnomalyDetails = ({
  created = null,
  distance = 0,
  title = '',
  journeyStartTs = null,
  journeyEndTs = null,
  tripId = null,
  t,
  isRecordedTrip = true,
}) => {
  return (
    <div>
      <Descriptions title={title} column={1} size="small" bordered>
        <Descriptions.Item label="Distance">{distance}</Descriptions.Item>
        <Descriptions.Item label="Start Date">{getTripDate(journeyStartTs)}</Descriptions.Item>
        <Descriptions.Item label="End Date">{getTripDate(journeyEndTs)}</Descriptions.Item>
        <Descriptions.Item label="Created Date">
          {isRecordedTrip ? getTripDate(created) : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Source">
          {isRecordedTrip ? (tripId ? 'Radar' : 'Kliks') : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="GPS">{isRecordedTrip ? 'Yes' : '-'}</Descriptions.Item>
      </Descriptions>
      {tripId && (
        <div style={{ marginTop: '10px', minHeight: '42px' }}>
          <RadarDashboardButton disabled={!isRecordedTrip} t={t} tripId={tripId} />
        </div>
      )}
    </div>
  );
};

export default TripAnomalyDetails;
